/*
 * @Author: your name
 * @Date: 2021-07-09 09:38:54
 * @LastEditTime: 2021-07-22 15:52:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\router\index.js
 */
import { createRouter, createWebHashHistory } from 'vue-router';
import routes from './router';

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
